import { Box, useTheme } from '@mui/material';
import { memo } from 'react';
import { BannerStatus } from '../../models/BannersModels';
import StatusContainer from './StatusTagStyles';

interface BannerStatusTagProps {
  status: BannerStatus;
  label: string;
}

function BannerStatusTag({ status, label }: BannerStatusTagProps) {
  const theme = useTheme();

  const colors = {
    [BannerStatus.SCHEDULED]: { font: '#007C92', bg: 'rgba(0, 124, 146, 0.1)' },
    [BannerStatus.ACTIVE]: { font: '#A8B400', bg: 'rgba(168, 180, 0, 0.10)' },
    [BannerStatus.EXPIRED]: { font: theme.palette.monochrome.monoChrome1, bg: 'rgba(51, 51, 51 , 0.5)' },
    [BannerStatus.DRAFT]: { font: theme.palette.text.secondary, bg: 'rgba(102, 102, 102, 0.10)' },
    [BannerStatus.CANCELED]: { font: theme.palette.primary.main, bg: 'rgba(230, 0, 0, 0.10)' },
  };

  return (
    <Box sx={{ display: 'flex' }}>
      <StatusContainer colors={colors[status]}>
        <span>{label}</span>
      </StatusContainer>
    </Box>
  );
}

export default memo(BannerStatusTag);
